// import React from "react";
// import { useWallet } from "../context/walletContext";
// import { formatAmount } from "../utils/formatAmount";
// import { useNavigate } from "react-router-dom";

// const WalletCard = ({ className = "" }) => {
//   const { walletAmt } = useWallet();
//   const navigate = useNavigate();

//   return (
//     <div
//       className={`ds-card ds-dash-panel flex flex-col justify-between h-full min-h-[160px] ${className}`.trim()}
//     >
//       <div>
//         <p className="text-[13px] font-semibold text-[var(--text-muted)] mb-1">
//           Wallet Balance
//         </p>
//         <p className="text-[24px] font-semibold text-[var(--text-dark)] leading-tight mb-1 tabular-nums">
//           ₹ {formatAmount(walletAmt?.main?.balance)}
//         </p>
//         <p className="text-[12px] text-[var(--success-color)] font-medium">
//           ▲ Available for transfers & payments
//         </p>
//       </div>
//       <div className="flex gap-2 mt-4">
//         <button
//           type="button"
//           onClick={() => navigate("/team")}
//           className="ds-btn ds-btn-ghost flex-1 text-[13px]"
//         >
//           Transfer
//         </button>
//         <button
//           type="button"
//           className="ds-btn ds-btn-secondary flex-1 text-[13px]"
//         >
//           Request
//         </button>
//       </div>
//     </div>
//   );
// };

// export default WalletCard;



import React from "react";
import { useWallet } from "../context/walletContext";
import { formatAmount } from "../utils/formatAmount";
import { useNavigate } from "react-router-dom";

const WalletCard = ({ className = "" }) => {
  const { walletAmt } = useWallet();
  const navigate = useNavigate();

  return (
    <div
      className={`
        ds-card
        ds-dash-panel
        flex
        flex-col
        justify-between
        h-full
        min-h-[160px]
        p-4
        ${className}
      `.trim()}
    >
      {/* Balance */}
      <div>
        <p className="text-[13px] font-semibold text-[var(--text-muted)] mb-1.5">
          Wallet Balance
        </p>

        <p className="text-[24px] font-semibold text-[var(--text-dark)] leading-tight mb-1.5 tabular-nums">
          ₹ {formatAmount(walletAmt?.main?.balance)}
        </p>

        <p className="text-[12px] text-[var(--success-color)] font-medium leading-relaxed">
          ▲ Available for transfers & payments
        </p>
      </div>

      {/* Actions */}
      <div className="flex gap-2 mt-4">
        <button
          type="button"
          onClick={() => navigate("/team")}
          className="ds-btn ds-btn-ghost flex-1 text-[13px]"
        >
          Transfer
        </button>

        <button
          type="button"
          className="ds-btn ds-btn-secondary flex-1 text-[13px]"
        >
          Request
        </button>
      </div>
    </div>
  );
};

export default WalletCard;
